var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.46877 27.0615C6.11931 25.6827 5.10131 24.015 4.49187 22.1845C3.88243 20.3541 3.69754 18.409 3.9512 16.4965C4.20486 14.584 4.89041 12.7543 5.95594 11.146C7.02147 9.53769 8.43902 8.19297 10.1012 7.21367C11.7634 6.23437 13.6267 5.64618 15.5499 5.49366C17.4731 5.34113 19.4058 5.62827 21.2016 6.33331C22.9974 7.03836 24.6092 8.14283 25.9149 9.56306C27.2206 10.9833 28.186 12.682 28.738 14.5306H31.9892C33.7429 14.5304 35.4501 15.0943 36.8587 16.1389C38.2674 17.1835 39.3026 18.6535 39.8117 20.3316C40.3207 22.0098 40.2765 23.8072 39.6856 25.4584C39.0946 27.1095 37.9883 28.5267 36.53 29.5008",
    stroke: "#191A1C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.999 21.7959V38.1428",
    stroke: "#191A1C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.264 29.0612L21.9987 21.7959L14.7334 29.0612",
    stroke: "#191A1C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.0576dddf757660259cab6ca023a32075.svg";
export { ForwardRef as ReactComponent };